import { TenantDisplayPalette } from '@askporter/client-grieg-lyric';
import { fallbackPalette } from '..';

export function mergeFallbackWithConfig(config: TenantDisplayPalette): Required<TenantDisplayPalette> {
  const filteredConfig = Object.fromEntries(
    Object.entries(config).filter(([, value]) => value !== undefined),
  ) as TenantDisplayPalette;

  return { ...fallbackPalette, ...filteredConfig } as Required<TenantDisplayPalette>;
}
